import { message } from "antd";
import {
  HOME_HIGHLIGHTS_UPLOAD_REQUEST,
  HOME_HIGHLIGHTS_UPLOAD_SUCCESS,
  HOME_HIGHLIGHTS_UPLOAD_FAIL,
  HOME_HIGHLIGHTS_FETCH_REQUEST,
  HOME_HIGHLIGHTS_FETCH_SUCCESS,
  HOME_HIGHLIGHTS_FETCH_FAIL,
  HOME_HIGHLIGHTS_DELETE_REQUEST,
  HOME_HIGHLIGHTS_DELETE_SUCCESS,
  HOME_HIGHLIGHTS_DELETE_FAIL,
} from "../../constants/admin/homeHighlightsConstants";
import axios from "../../../axiosInstance";

// 🔹 Upload home highlights images
export const uploadHomeHighlights = (images) => async (dispatch) => {
  try {
    dispatch({ type: HOME_HIGHLIGHTS_UPLOAD_REQUEST });

    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images", image);
    });

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const { data } = await axios.post(
      "/api/v1/home-highlights/upload",
      formData,
      config
    );

    if (data?.success === true) {
          dispatch({ type: HOME_HIGHLIGHTS_UPLOAD_SUCCESS, payload: data });
          message.success(data?.message || "Home highlights images added successfully");
        } else {
          throw new Error(data?.message || "Failed to home highlights images");
        }
  } catch (error) {
    dispatch({
      type: HOME_HIGHLIGHTS_UPLOAD_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to about highlights images"
    );
  }
};

// Fetch home highlights images 
export const fetchHomeHighlights = () => async (dispatch) => {
  try {
    dispatch({ type: HOME_HIGHLIGHTS_FETCH_REQUEST });

    const { data } = await axios.get("/api/v1/home-highlights/get");
    dispatch({ type: HOME_HIGHLIGHTS_FETCH_SUCCESS, payload: data.homeHighlights });
  } catch (error) {
    dispatch({
      type: HOME_HIGHLIGHTS_FETCH_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};

// 🔹 Delete home highlights image
export const deleteHomeHighlights = (publicId) => async (dispatch) => {
  try {
    dispatch({ type: HOME_HIGHLIGHTS_DELETE_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.delete("/api/v1/home-highlights/delete", {
      data: { publicId },
      ...config,
    });
    if (data?.success === true) {
      dispatch({ type: HOME_HIGHLIGHTS_DELETE_SUCCESS, payload: data });
      message.success(data?.message || "Home highlights image deleted successfully");
    } else {
      throw new Error(data?.message || "Failed to home highlights images");
    }
  } catch (error) {
    dispatch({
      type: HOME_HIGHLIGHTS_DELETE_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to about highlights images"
    );
  }
};
